// /lib/utils.ts
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import {
  GlobalSearchIcon,
  Database02Icon,
  ChattingIcon,
  AiImageIcon,
} from '@hugeicons/core-free-icons';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type SearchGroupId =
  | 'web'
  | 'chat'
  | 'image'
  | 'memory'
  // Legacy groups — hidden, tools removed, requests fall back to 'web' in getGroupConfig
  | 'x'
  | 'academic'
  | 'youtube'
  | 'reddit'
  | 'stocks'
  | 'extreme'
  | 'crypto'
  | 'code'
  | 'connectors';

// Search provider information for dynamic descriptions
export const searchProviderInfo = {
  parallel: 'Parallel AI',
  exa: 'Exa',
  tavily: 'Tavily',
  firecrawl: 'Firecrawl',
} as const;

export type SearchProvider = keyof typeof searchProviderInfo;

// Function to get dynamic web search description based on selected provider
export function getWebSearchDescription(provider: SearchProvider = 'exa'): string {
  const providerName = searchProviderInfo[provider];
  return `Search across the entire internet powered by ${providerName}`;
}

export type SearchGroup = {
  id: SearchGroupId;
  name: string;
  description: string;
  icon: any;
  show: boolean;
  requireAuth?: boolean;
  requirePro?: boolean;
};

// Function to get search groups with dynamic descriptions
export function getSearchGroups(searchProvider: SearchProvider = 'exa'): SearchGroup[] {
  return [
    {
      id: 'chat',
      name: 'Чат',
      description: 'Прямое общение с AI-моделью',
      icon: ChattingIcon,
      show: true,
    },
    {
      id: 'web',
      name: 'Веб',
      description: 'Поиск информации в интернете',
      icon: GlobalSearchIcon,
      show: false,
    },
    {
      id: 'image',
      name: 'Создать изображение',
      description: 'Генерация изображений по описанию',
      icon: AiImageIcon,
      show: true,
    },
    {
      id: 'memory',
      name: 'Память',
      description: 'Личная память AI-ассистента',
      icon: Database02Icon,
      show: false,
      requireAuth: true,
    },
  ];
}

// Keep the static searchGroups for backward compatibility
export const searchGroups = getSearchGroups();
